export function Environment () {
    this.$document = $(document);
    this.$window = $(window);
    this.$html = $(document.documentElement);
    this.$body = $(document.body);
    this.$header = $('.js-header');
}

export function isLocal () {
    const split = location.hostname.split('.');
    return (split[0] === 'localhost' || split[1] === 'localhost' || split[1] === 'local' || split[1] === 'dev' || split[1] === '127.0.0.1');
}



// WEBPACK FOOTER //
// ./app/src/js/utils/environment.js